/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars */ import React, {  useContext,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';

import Loading from '../../../components/loading/Loading';
import api from '../../../service/axios/api';
import FlashContext from '../../../components/contexts/FlashContext';

export default function DownloadXls({ openDownload, setOpenDownload }) {
  const { t } = useTranslation();
  const { notifyError } = useContext(FlashContext);

  const [loading, setLoading] = useState(false);

  const getXls = async type => {
    setLoading(true);
    try {
      const { data } = await api.receivables.getXls(type);
      const url = data.retorno.link;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'recebiveis.xlsx');
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      if (error.problems && error.problems.length > 0) {
        error.problems.forEach(err => {
          notifyError(err.msg);
        });
      } else {
        notifyError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      onClose={() => setOpenDownload(false)}
      open={openDownload}
      fullWidth
      maxWidth="sm"
    >
      <Loading open={loading} msg={t('receivables.downloadDialog.loading')} />
      <DialogTitle id="simple-dialog-title">
        {t('receivables.downloadDialog.title')}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={4}
          style={{
            justifyContent: 'center',
          }}
        >
          <Grid item xs={12} sm={8}>
            <p
              style={{
                fontSize: '20px',
                textAlign: 'justify',
              }}
            >
              {`${t('receivables.downloadDialog.message')}`}
            </p>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          style={{ height: 40 }}
          onClick={() => setOpenDownload(false)}
          variant="text"
          color="primary"
        >
          {t('receivables.downloadDialog.buttons.cancel')}
        </Button>
        <Button
          onClick={() => getXls('predicted')}
          variant="contained"
          disabled={loading}
          color="primary"
        >
          {t('receivables.downloadDialog.buttons.predicted')}
        </Button>
        <Button
          onClick={() => getXls('pending')}
          variant="contained"
          disabled={loading}
          color="primary"
        >
          {t('receivables.downloadDialog.buttons.pending')}
        </Button>
        <Button
          onClick={() => getXls('received')}
          variant="contained"
          disabled={loading}
          color="primary"
        >
          {t('receivables.downloadDialog.buttons.received')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
